import { Link } from "react-router-dom";
import { movieItems, tvItems } from "@/utils/catalog";

const shortcuts = [
  {
    to: "/movies",
    tag: "电影库",
    title: "最新电影",
    desc: "院线热映、口碑佳作、经典回顾，按类型与评分快速筛选。",
    count: movieItems.length,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinema%20hall%20scene%2C%20rows%20of%20glowing%20seats%20facing%20a%20bright%20warm%20screen%2C%20deep%20navy%20auditorium%20with%20warm%20amber%20light%20spilling%20from%20the%20screen%2C%20elegant%20minimalist%20editorial%20composition%2C%20high%20detail&width=800&height=600&seq=keke-cat-movie&orientation=landscape",
  },
  {
    to: "/tvseries",
    tag: "剧集库",
    title: "热门电视剧",
    desc: "国剧、海外剧、年代与都市题材，追更不过时。",
    count: tvItems.length,
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20living%20room%20at%20night%20watching%20a%20glowing%20television%2C%20warm%20ambient%20lamplight%2C%20deep%20navy%20shadows%20with%20cozy%20amber%20highlights%2C%20minimalist%20editorial%20composition%2C%20cinematic%20high%20detail&width=800&height=600&seq=keke-cat-tv&orientation=landscape",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mb-6 md:mb-8">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
          快捷入口
        </span>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          按类型快速发现
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {shortcuts.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="group relative flex h-56 overflow-hidden rounded-lg border border-background-200/80 md:h-64"
          >
            <img
              src={item.image}
              alt={`${item.title}入口`}
              title={`${item.title} 影视分类`}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
            <div className="relative z-10 flex w-full flex-col justify-end p-6 md:p-8">
              <span className="w-fit rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                {item.tag}
              </span>
              <h3 className="mt-3 font-heading text-2xl font-bold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 max-w-md text-sm text-background-100/85">{item.desc}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-background-200/80">
                  收录 {item.count} 部作品
                </span>
                <span className="flex items-center gap-1 text-sm font-medium text-accent-400">
                  进入分类
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}